<template>
  <div>
    <ul class="rating-list">
      <li
        @click="setRate(rating)"
        :class="`type_${rating.value}`"
        v-for="rating in ratings"
        :key="rating.id"
      >
        <label><span>{{ rating.value }}</span></label>
      </li>
      <li @click="setRate()" class="type_add">
        <span class="icon ti-plus"></span>
      </li>
    </ul>

    <set-rating
      v-if="openRate"
      @close="openRate = false"
      v-model="rate"
      :getJournal="getJournal"
      :table="table"
      :client="client"
      :modal="`r_${table.id}_${client.id}`"
    />
  </div>
</template>

<script>
import SetRating from "./SetRating.vue";
export default {
  watch: {
    client: {
      handler: function (val) {
        this.ratings = [];
        for (let i = 0; i < this.value.length; i++) {
          if (this.value[i].timetable_id == this.table.id) {
            this.ratings.push(this.value[i]);
          }
        }
      },
      deep: true,
    },
  },
  async created() {
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i].timetable_id == this.table.id) {
        this.ratings.push(this.value[i]);
      }
    }
  },
  data() {
    return {
      rate: { value: 0, work: {} },
      ratings: [],
      openRate: false,
    };
  },
  props: ["client", "value", "table", "getJournal"],

  methods: {
    async setRate(rating = null) {
      let work = {};
      if (
        !rating &&
        this.table.lessonplan.works &&
        this.table.lessonplan.works.length
      ) {
        work = await this.table.lessonplan.works[0];
      }

      this.openRate = true;
      setTimeout(() => {
        this.rate = rating ? rating : { value: 0, work: work };
        this.$modal.show(`r_${this.table.id}_${this.client.id}`);
      }, 10);
    },
  },
  components: { SetRating },
};
</script>

<style lang="scss">
.rating-list {
    /*
    FF4C00
    D75D5D
    F5BF33
    33C7F5
    A1D75D
     */
  margin-left: -4px;
  margin-right: -4px;
  display: flex;
  &:hover{
    li{
      transform: scale(0.98) translateX(2px);
    }
  }
  & > li {
    padding-left: 4px;
    padding-right: 4px;
    transition: 0.2s ease;
    border-radius: 50%;
    &:hover{
      z-index: 1;
      transform: scale(1.15);
      label{
        box-shadow: 0 0px 20px -3px currentColor;
      }
      &~li:not(.active){
        transform:scale(0.98) translateX(-2px);
      }
    }
    &.active{
      z-index: 1;
      transform: scale(1.15);
      label{
        box-shadow: 0 0px 20px -3px currentColor;
      }
    }
    &>span, label>span{
      color: white;
    }
    &>span:last-child:first-child, label{
      color: inherit;
      position: relative;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: currentColor;
      transition: 0.3s ease;
      &:hover{
        cursor: pointer;
      }
      &[class*='ti-']{
        &:before{
          color: white;
        }
      }
    }
    &.type_add {
        color:  #777;
    }
    &.type_0 {
        color:  green;
    }
    &.type_1 {
        color:  #FF4C00;
    }
    &.type_2 {
        color:  #D75D5D;
    }
    &.type_3 {
        color:  #F5BF33;
    }
    &.type_4 {
        color:  #33C7F5;
    }
    &.type_5 {
        color:  #A1D75D;
    }

  }
}
</style>

